import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './expiredPlanPanel.module.css';

const ExpiredPlanPanel = ({ onCancel }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                {onCancel && (
                    <button className={styles.closeButton} onClick={onCancel} aria-label={t("Close")}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                )}
                <div className={styles.iconWrapper}>
                    <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em">
                        <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" clipRule="evenodd" />
                    </svg>
                </div>

                <h2 className={styles.title}>
                    {t("Your plan has expired")}
                </h2>

                <p className={styles.description}>
                    {t("Please renew your plan to continue accessing all premium features.")}
                </p>

                <Link to="/payments" className={styles.renewButton}>
                    {t("Renew or Upgrade Your Plan")}
                    <svg className={styles.arrowIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="1em" height="1em">
                        <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                    </svg>
                </Link>
            </div>
        </div>
    );
};

export default ExpiredPlanPanel;
